<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-goto [ttText]="'productslinks_productlinkschange'" [ttGoto]="'productlinkschange'" [ttGotoParms]="{ argtype: setting.argtype, argvalue: setting.argvalue, productlinktype_keyno: setting.productlinktype_keyno }"></tt-button-goto>

        <tt-tabs ttRememberId="w_productlinks.bg_productlinks" [(ttSelectedId)]="setting.bg_productlinks" (ttSelectedIdChange)="onTabChange()">
            <tt-tab ttId="GOTO" ttLabel="bg_productlinks_goto"></tt-tab>
            <tt-tab ttId="EDIT" ttLabel="bg_productlinks_edit"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListLinks"></tt-list>
</tt-page>
